import { render, staticRenderFns } from "./WidgetNetworkTopAgencies.vue?vue&type=template&id=0639c668"
import script from "./WidgetNetworkTopAgencies.vue?vue&type=script&lang=js"
export * from "./WidgetNetworkTopAgencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports